import type { Root, Text } from 'mdast';
import { visit } from 'unist-util-visit';

import { ALLOWED_DIRECTIVES } from './consts';

/**
 * Маппит remark-directive ноды в hast-теги вида `directive-<name>`.
 * Атрибуты директивы (`{title="..."}`) пробрасываются в hProperties.
 * Имена с дефисом — валидные custom-element имена и проходят через
 * react-markdown components map без переопределения схемы.
 */
export function remarkDirectiveTags() {
	return (tree: Root) => {
		visit(tree, (node, index, parent) => {
			if (
				node.type !== 'containerDirective' &&
				node.type !== 'leafDirective' &&
				node.type !== 'textDirective'
			) {
				return;
			}

			const directiveNode = node as typeof node & {
				name: string;
				children?: Root['children'];
				attributes?: Record<string, string | null | undefined>;
				data?: { hName?: string; hProperties?: Record<string, unknown> };
			};

			if (!ALLOWED_DIRECTIVES.has(directiveNode.name as never)) {
				// Не наша директива (например, `:N` в тексте «модель M:N»):
				// remark-directive уже распарсил синтаксис и оставил бы пустую
				// ноду. Возвращаем литеральный текст `:имя`, чтобы двоеточие с
				// буквами отображалось как обычный текст, а не исчезало.
				if (parent && typeof index === 'number') {
					const marker =
						node.type === 'containerDirective'
							? ':::'
							: node.type === 'leafDirective'
								? '::'
								: ':';
					const text: Text = {
						type: 'text',
						value: `${marker}${directiveNode.name}`,
					};
					parent.children.splice(
						index,
						1,
						text,
						...(directiveNode.children ?? []),
					);
				}
				return;
			}

			const data = directiveNode.data || (directiveNode.data = {});
			data.hName = `directive-${directiveNode.name}`;
			data.hProperties = { ...(directiveNode.attributes || {}) };
		});
	};
}
